import { useQuery } from "@tanstack/react-query";
import { getQuestion } from "@/services/apiService";
import { QuestionCard } from "@/components/QuestionCard";
import { AnswerForm } from "@/components/AnswerForm";

export const HeroSection = () => {
  const { data: question, isLoading } = useQuery({
    queryKey: ["question-today"],
    queryFn: getQuestion,
  });

  return (
    <section
      id="home"
      className="hero-gradient text-white px-4 text-center py-20 min-h-screen flex flex-col items-center justify-center"
    >
      <div className="max-w-3xl mx-auto space-y-12 fade-in w-full">
        <div className="space-y-3">
          <h1 className="text-5xl font-bold">Dove Bot</h1>
          <p className="text-xl text-white/70">Asking the world for help</p>
        </div>

        {isLoading && (
          <p className="text-white/50 animate-pulse">Loading today's question...</p>
        )}

        {!isLoading && !question && (
          <p className="text-white/60 text-lg">No question today. Check back tomorrow.</p>
        )}

        {!isLoading && question && (
          <div className="space-y-8">
            <QuestionCard
              personaName={question.persona_name}
              question={question.question}
            />
            <AnswerForm questionId={question.id} />
          </div>
        )}
      </div>
    </section>
  );
};
